import {useCallback} from 'react';
import {setValue} from 'src/v2/state/store';
import {isMobile, setUrlParam} from 'src/utils/utils';
import {useWalletConnectionClient} from 'src/v2/state/walletConnection';
import {logger} from 'src/utils/logger';
import type {PaymentOption} from 'src/v2/state/types';

export const useWalletPress = () => {
  const walletClient = useWalletConnectionClient();

  return useCallback(
    (walletOption: PaymentOption) => {
      const {provider} = walletOption;
      logger.info('selecting wallet', {
        provider,
        key:
          provider === 'WalletConnect' || provider === 'Exchange'
            ? walletOption.key
            : null,
      });

      if (provider === 'Exchange') {
        setValue((state) => {
          state.exchangeOption = walletOption;
          state.screen = 'EXCHANGE';
        });
        return;
      }

      setUrlParam(
        'selectedWallet',
        provider === 'WalletConnect' ? walletOption.key : provider,
        walletClient,
      );

      setValue((state) => {
        state.newWallet = {
          walletOption,
          networkType: provider === 'WalletConnect' ? 'evm' : null,
        };
        state.screen =
          provider === 'WalletConnect' ||
          ('isInstalledOnBrowser' in walletOption &&
            walletOption.isInstalledOnBrowser) ||
          isMobile()
            ? 'NETWORK_SELECT'
            : 'INSTALL_WALLET';
      });
    },
    [walletClient],
  );
};
